import { render, staticRenderFns } from "./UserPasswordActions.vue?vue&type=template&id=475abc4e&"
import script from "./UserPasswordActions.vue?vue&type=script&lang=ts&"
export * from "./UserPasswordActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports